import { ArrowLeftOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import { withFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getMasterCurrencies } from '../../../../Actions/UserAction'
import Button from '../../../../Components/Button'
import Field from '../../../../Components/Formik/Field'
import Form from '../../../../Components/Formik/Form'
import Panel from '../../../../Layout/Panel'
import PanelLayout from '../../../../Layout/PanelLayout'
import apiClient from '../../../../Util/apiClient'
import { PRICE_TYPES } from '../../../../Util/Options'
import { priceChargeSchema } from '../../../../Util/validationSchema'

function PriceChargeForm({
  values,
  setValues,
  match: {
    params: { id }
  }
}) {
  const [currencies, setCurrencies] = useState([])

  const getData = () => {
    getMasterCurrencies().then((data) => setCurrencies(data))

    if (id) {
      apiClient.get(`price-charges/${id}`).then(({ status, data }) => {
        if (status === 200) {
          setValues({ ...values, ...data })
        }
      })
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <Form>
      <Row justify="center" className="inner-contents">
        <Col xs={22} sm={22} md={20} lg={20}>
          <PanelLayout title="Price Charge Definition">
            <Panel title="Price Charge">
              <Row gutter={[20, 10]}>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field as="select" name="type" label="Type" options={PRICE_TYPES} />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field name="description" label="Description" />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field name="country" label="Country" />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field as="select" name="currency" label="Currency" options={currencies} />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field type="number" name="price" label="Price" />
                  </div>
                </Col>
              </Row>
            </Panel>
          </PanelLayout>
          <div className="save-changes">
            <Button type="submit" variant="primary">
              {id ? 'Update' : 'Save'}
            </Button>
            <span>or</span>
            <Link to="/app/price-charges">
              <Button>
                <ArrowLeftOutlined /> Back to price charges
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues: () => ({
    type: '',
    description: '',
    country: '',
    currency: '',
    price: ''
  }),
  validationSchema: priceChargeSchema,
  handleSubmit: (
    data,
    {
      props: {
        match: {
          params: { id }
        },
        history
      }
    }
  ) => {
    if (id) {
      apiClient.put(`price-charges/${id}`, data).then(({ status }) => {
        if (status === 200) {
          history.push('/app/price-charges')
        }
      })
    } else {
      apiClient.post('price-charges', data).then(({ status }) => {
        if (status === 201) {
          history.push('/app/price-charges')
        }
      })
    }
  }
})(PriceChargeForm)
